import { createAsyncThunk } from "@reduxjs/toolkit";
import { PortfolioTracking } from "../../models/Portfolio";
import { LeoService } from "../../services/leoService";


export const loadPortfolioTracking = createAsyncThunk<PortfolioTracking, string>(
    'portfolioTracking/loadPortfolioTracking',
    async (id: string) => {
        const leoService = new LeoService();
        return await leoService.GetPortfolioTracking(id)
    });